/* eslint-disable react/react-in-jsx-scope */
import { Button, Card } from 'antd';
import LocaleContext from 'locales';
import { useContext, useEffect } from 'react';
import { checkExternalAccess } from 'services/mgmt';

/**
 * 기본 OTP 인증: Google/Microsoft Authenticator
 * @param {object} credential {success(인증 성공 여부), idpw(id/pw 인증 정보), twoFactor}
 * @param {function} loginDispatch loginState의 dispatch
 * @returns ReactNode
 */

function ExternalAccess({ history }) {
  useEffect(() => {
    checkExternalAccess().then(({ isExternalAccess }) => {
      sessionStorage.setItem('isExternalAccess', isExternalAccess);
      if (!isExternalAccess) {
        history.push({
          pathname: '/auth/login',
        });
      }
    });
  }, []);

  const { locale } = useContext(LocaleContext);
  const moveLoginPage = () => {
    history.push({
      pathname: '/auth/login',
    });
  };
  const textResource = {
    'ko-KR': {
      title: 'WARNING',
      contents: (
        <>
          <p>
            현재 귀하는 사외에서 EnCloud에 접속하셨습니다.
            <br />
            사외에서는 회사 정보가 노출될 위험이 높으므로 안전한 환경에서 이용하시기 바랍니다.
          </p>
          <p>
            사외에서 접속 시 모든 행위는 기록 및 저장되며 아래 보안 유의사항을 준수하여 주시고,
            회사의 보안규정을 위반할 경우 권한 회수 및 징계 등의 불이익을 받을 수 있음을 유념하여
            주시기 바랍니다.
          </p>
          <strong>{`<사외에서 업무 시 보안 유의사항>`}</strong>
          <ul>
            <li>업무 내용을 촬영하는 행위 금지</li>
            <li>외부인에 노출되기 쉬운 카페, PC방 등의 공공장소에서 업무 지양</li>
            <li>자리 비울 경우 화면 잠금(윈도우키 + L) 설정</li>
            <li>관계자 외 업무 내용 공유 금지</li>
            <li>기타 당사 정보가 노출/유출 될 수 있는 행위 금지</li>
          </ul>
        </>
      ),
      agreeBtn: '동의',
      disagreeBtn: '비동의',
    },
    'en-US': {
      title: 'WARNING',
      contents: (
        <>
          <p>
            You have accessed the EnCloud from outside now.
            <br />
            There is a high risk of exposing company&apos;s information, so please use it in a safe
            place like home, office.
          </p>
          <p>
            All actions will be recorded and stored when accessing outside, and Violations of these
            may result in disadvantages such as taking the authority back and disciplinary action.
          </p>
          <strong>{`<Security Precautions for Working Outside>`}</strong>
          <ul>
            <li>- Do not photograph the contents of your work.</li>
            <li>- Do not expose/leak an information about the company.</li>
            <li>- Do not share business information other than work-related people.</li>
            <li>
              - Avoid work in public places such as cafes and internet cafes that can be exposed to
              outsiders.
            </li>
            <li>- If you&apos;re away, set the screen lock(Windows Key + L).</li>
          </ul>
        </>
      ),
      agreeBtn: 'Agree',
      disagreeBtn: 'Disagree',
    },
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#f5f5f5', // 배경색은 선택사항
      }}
    >
      <Card
        title={
          <div
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: '50px',
              lineHeight: 1.2,
            }}
          >
            {textResource[locale.param].title}
          </div>
        }
        style={{ width: 700 }}
      >
        <div style={{ marginBottom: 24, textAlign: 'left', fontSize: 14 }}>
          {textResource[locale.param].contents}
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px' }}>
          <Button size="large" onClick={moveLoginPage} type="primary">
            {textResource[locale.param].agreeBtn}
          </Button>
          <Button size="large" type="default">
            {textResource[locale.param].disagreeBtn}
          </Button>
        </div>
      </Card>
    </div>
  );
}

export default ExternalAccess;
